import './title5.css'
export default function Title5(){
    return(
        <>
       <div className="h"> <div className="head-5">
       </div></div>
        <div className="t">
        <h3 className='t-1'>Concentrated Spice Mixes</h3>
        </div>
        </>
    )
}